import React from 'react';
import { Center, VStack } from 'native-base';
import { useI18n, useSpringBigStore } from '@springbig/shared';
import QrCode from '~/shared/QrCode';
import ReferSocialMedia from './components/ReferSocialMedia';
import ReferCopyLink from './components/ReferCopyLink';
import ReferRewards from './components/ReferRewards';
import { useToast } from '~/hooks/toast';
import { useCopyToClipboard } from 'usehooks-ts';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';
import { Panel, Card, Section } from '~/shared/Theme';

export const ReferScreen = () => {

    const { member } = useSpringBigStore();
    const { t } = useI18n();
    const { successToast } = useToast();
    const [value, copy] = useCopyToClipboard();

    const { isLoadingAuth } = useAuthorization();

    const handleClipboard = (target?: string) => {

        copy(member?.referrals?.link);
        successToast(t('refer.link_copied'));

        if (target && /(https?:\/\/|www\.)/.test(target)) {
            window.open(target, '_blank');
        }
    };

    if (isLoadingAuth) {
        return <Loading isLoading={isLoadingAuth} />;
    }

    return (
        <Section>
            <VStack space={4} py={4}>
                <Center>
                    <Card w={48} h={48}>
                        <QrCode
                            value={member && member.referrals?.link || 'www.google.com'}
                        />
                    </Card>
                </Center>
                <Panel>
                    { member?.referrals?.referrer_offer_name &&
                            <ReferRewards member={member} />
                    }
                    <ReferCopyLink
                        member={member}
                        copyToClipboard={handleClipboard}
                        link={'refer.copy_link'}
                    />
                </Panel>
                <Panel>
                    <ReferSocialMedia copyToClipboard={handleClipboard} />
                </Panel>
            </VStack>
        </Section>
    );
};

export default ReferScreen;
